import { SignUpHeader } from '../components/SignUpHeader';
import { SignUpStep2Form } from '../components/SignUpStep2Form';
import { RedirectIfAuthed } from '../../lib/use-auth';

export default function SignUpStep2Page() {
  return (
    <RedirectIfAuthed>
      <div className="bg-white min-h-screen flex flex-col">
        <SignUpHeader showBackButton={true} mode="signin" />
        <main className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4 w-full">
          <SignUpStep2Form />
        </main>
      </div>
    </RedirectIfAuthed>
  );
}
